// Functional component for the header menu (only in mobile view) with a button for displaying the navbar

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/free-solid-svg-icons";
import { useContext } from "react";
import { ThemeContext } from "../App";

interface HeaderProps {
  navbarIsActive: boolean;
  toggleNavbar(): void;
}

export const Header = (props: HeaderProps) => {
    const { theme } = useContext(ThemeContext);

    return (
        <div className="header" id={theme}>
            <div onClick={props.toggleNavbar}>
                <FontAwesomeIcon className="fa-solid fa-bars" icon={faBars} />
            </div>
        </div>
    );
};
